import type { DiscoveredRouteModule } from '@/router/generator/types';

// Local constants
const ArchiveView = () => import('@/views/ArchiveView.vue');
export const NAME_ARCHIVE = 'Archive';
export const PATH_ARCHIVE = 'archive';

export const route: DiscoveredRouteModule = {
  id: 'app.archive',
  scope: 'app',
  moduleKey: 'archive',
  name: NAME_ARCHIVE,
  path: PATH_ARCHIVE,
  component: ArchiveView,
  meta: {
    dataLoaders: ['project_archive']
  },
  requiresFeature: 'archive'
};


